import fetch from '@/plugins/axios'
export default {
	namespaced: true,
	state: {
        list: [],
		pager: {},
		loading: false
	},
	mutations: {
		setState(state: any, { key, data }: any) {
			state[key] = data;
		}
	},
	actions: {
		// 获取充值记录
		async getRechangeList({ commit }: any, params: any) {
			commit('setState',{key:'loading',data: true})
			const res:any = await fetch({
                url: '/client/capitalflow',
                params
			})
			commit('setState',{key:'list',data: res.docs})
			commit('setState',{key:'pager',data: {limit: res.limit,total: res.total}})
			commit('setState',{key:'loading',data: false})
        },
        // 撤销充值
        async revocation({ commit }: any,id: any) {
			return await fetch({
                url: `/client/capitalflow/${id}`,
                method: 'delete'
			})
        },
	}
}